import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'coupon',
		pluralName: 'coupons',
		transport: 'davinci'
	});
}
